
import { Field } from "../../components/types/stylepacks";
import type { GraphicInterface } from "./graphics";
import type { MediaItem } from "./media";
import type { UserMedia } from "./media";

export interface MediaBackground {
	image: string;
	thumb: string;
}

export type Blur = 'high' | 'low' | 0;

export interface VirtualBg {
	uniqueId: string;
	url: string;
	blur: Blur;
	id?: number; // id of database entry
	thumbnail?: string;
	name?: string;
	fileType?: string;
}

export interface TemplateData {
	apiVersion: string;
	config?: {
		[key: string]: any;
	};
	thumbnail: {
		id: string;
		url: string;
		title: string;
		width: number;
		height: number;
		contentType: string;
	};
	variables: Field[];
	duration?: number;
	assets: {name:string}[];
}

export interface GeneratedContentRequest {
	templateId: number;
	id: number;
	fkTable: FkTable;
	fkId?: number;
	version: number;
	graphic?: GraphicInterface;
	mediaItem?: MediaItem;
	data: GeneratedContentData[];
	contentUrl: string;
	jobId?: string;
	jobStatus?: string;
}

export interface GeneratedContentData {
	key: string;
	value: string;
}

export enum ContentServiceJobStatus {
	completed = 'completed',
	processing = 'processing',
	exporting = 'exporting',
	failed = 'failed',
}

export enum FkTable {
	graphics = 'gr_graphics',
	media = 'gr_media',
}

export interface GeneratedContent {
	id?: number;
	templateId: number;
	dateCreated?: Date;
	createdBy?: number;
	dateUpdated?: Date;
	updatedBy?: number;
	jobId?: string;
	jobStatus?: ContentServiceJobStatus;
	contentUrl?: string;
	provider: string;
	type: string;
	fkTable: FkTable;
	fkId?: number;
	data: GeneratedContentData[];
	config?: {
		[key: string]: any;
	};
	themeId?: number;
	currentThemeVersion?: number;
	version: number;
	apiVersion?: string;
}

export interface ContentState {
	event: any;
	isLoadingEvent: boolean;
	eventError: boolean;
	loadedEvent: any;
	events: any[];
	loadingEvents: boolean;
	eventsError: string | null;
	meetings: any[];
	loadingMeetings: boolean;
	meetingsError: string | null;
	liveChannels: number[];
	defaultBackgrounds: MediaBackground[];
	virtualBackgrounds: VirtualBg[];
	defaultVBGS: VirtualBg[];
	loadingVbgs: boolean;
	recentVbgUpload: boolean;
	selectedVBGUrl: string | null;
	selectedVBG: VirtualBg | null;
	uploadingVbgs: Map<string, boolean>;
}

export interface RegeneratingContent {
	id: number;
	version: number;
}